import { z } from 'zod';
import { BankAccountPayload, BaseBankAccountPayloadSchema } from './bank-account.payload.entity';

export const IntradagclearingBankAccountPayloadSchema = BaseBankAccountPayloadSchema.merge(
    z.object({
        accountNumber: z.string(),
        bankCode: z.string(),
        swiftCode: z.string().optional(),
        iban: z.string().optional(),
    }),
);

export class IntradagclearingBankAccountPayload extends BankAccountPayload {
    bankCode: string;
    accountNumber: string;
    swiftCode?: string;
    iban?: string;
}
